import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined"
import HorizontalRuleOutlinedIcon from "@mui/icons-material/HorizontalRuleOutlined"
import RectangleOutlinedIcon from "@mui/icons-material/RectangleOutlined"
import TextFieldsOutlinedIcon from "@mui/icons-material/TextFieldsOutlined"
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined"
import Box from "@mui/material/Box"
import Grid from "@mui/material/Grid"
import { memo } from "react"
import { selectUndoable } from "../../../helpers/selector.helpers"
import { useObjectActions } from "../../../hooks/useObjectActions"
import { useAppSelector } from "../../../hooks/useRedux"
import { selectVideoPanelExists } from "../../../store/slices/objects.slice"
import AddButton from "../../common/AddButton"
import CrawlTickerButton from "./CrawlTickerButton"
import LoadImageButton from "./LoadImageButton"
import LoadSequenceButton from "./LoadSequenceButton"
import ObjectsTreeControlExpand from "./ObjectsTreeControlExpand"
import ScrollTickerButton from "./ScrollTickerButton"

const ObjectsTreeActions = () => {
    const { addRootObject, addVideoPanel } = useObjectActions()
    // subscribed here, not in useObjectActions — that hook runs once per canvas object and
    // must not render anything derived from the objects slice
    const videoPanelExists = useAppSelector((state) =>
        selectVideoPanelExists(selectUndoable(state).objects)
    )

    return (
        <>
            <Grid sx={{ mb: 0.5 }} id="editor-step-1">
                <AddButton
                    text="rectangle"
                    handleAddObject={() => addRootObject()}
                    icon={<RectangleOutlinedIcon fontSize="small" />}
                />
                <AddButton
                    text="ellipse"
                    handleAddObject={() => addRootObject("ellipse")}
                    icon={<CircleOutlinedIcon fontSize="small" />}
                />
                <AddButton
                    text="line"
                    handleAddObject={() => addRootObject("line")}
                    icon={<HorizontalRuleOutlinedIcon fontSize="small" />}
                />
                <AddButton
                    text="text"
                    handleAddObject={() => addRootObject("text")}
                    icon={<TextFieldsOutlinedIcon fontSize="small" />}
                />
                <LoadImageButton />
                <LoadSequenceButton />
                <AddButton
                    visible={false} //temporarily hide video panel option
                    disabled={videoPanelExists}
                    text="video panel"
                    handleAddObject={addVideoPanel}
                    icon={<VideocamOutlinedIcon fontSize="small" />}
                />
                <CrawlTickerButton />
                <ScrollTickerButton />
            </Grid>
            <Box sx={{ mb: 0.5, display: "flex", justifyContent: "flex-end" }}>
                <ObjectsTreeControlExpand />
            </Box>
        </>
    )
}

export default memo(ObjectsTreeActions)
